import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Newspaper, Loader2 } from "lucide-react";
import { toast } from "sonner";

const OPTIONS = [
  {
    key: "all",
    label: "Digest complet",
    desc: "Toutes les catégories que tu suis, chaque dimanche à 9h.",
  },
  {
    key: "important_only",
    label: "Important uniquement",
    desc: "Seuls les alertes urgentes et les infos prioritaires (CROUS, arnaques, maintenance).",
  },
  {
    key: "off",
    label: "Désactivé",
    desc: "Aucun digest hebdomadaire. Tu recevras encore les notifs unitaires (si activées).",
  },
];

export default function DigestModeSection() {
  const [mode, setMode] = useState("all");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/digests/preview");
        setMode(data.mode || "all");
      } catch { /* silent */ } finally {
        setLoading(false);
      }
    })();
  }, []);

  const pick = async (next) => {
    if (next === mode) return;
    setSaving(true);
    setMode(next);
    try {
      await api.put("/digests/mode", { mode: next });
      toast.success("Préférence de digest enregistrée");
    } catch {
      toast.error("Sauvegarde impossible");
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <section className="rounded-2xl border border-slate-200 bg-white p-6" data-testid="digest-mode-card">
        <div className="flex items-center gap-2 text-sm text-slate-400">
          <Loader2 size={14} className="animate-spin" /> Chargement…
        </div>
      </section>
    );
  }

  return (
    <section
      className="rounded-2xl border border-slate-200 bg-white p-6"
      data-testid="digest-mode-card"
    >
      <div className="flex items-start gap-3">
        <div className="w-9 h-9 rounded-lg bg-fuchsia-50 text-fuchsia-600 flex items-center justify-center shrink-0">
          <Newspaper size={18} />
        </div>
        <div className="flex-1">
          <p className="font-medium text-slate-900">Digest hebdomadaire</p>
          <p className="text-sm text-slate-500">
            Chaque dimanche matin à 9h, on te prépare un résumé personnalisé de la semaine sur Student Hub.
          </p>
        </div>
      </div>

      <ul className="mt-5 space-y-2" data-testid="digest-mode-options">
        {OPTIONS.map((o) => {
          const selected = mode === o.key;
          return (
            <li key={o.key}>
              <button
                onClick={() => pick(o.key)}
                disabled={saving}
                className={`w-full text-left rounded-xl border px-4 py-3 transition-colors flex items-start gap-3 ${
                  selected
                    ? "border-fuchsia-500 bg-fuchsia-50"
                    : "border-slate-200 hover:border-slate-300 bg-white"
                }`}
                data-testid={`digest-mode-${o.key}`}
              >
                <span className={`mt-0.5 w-4 h-4 rounded-full border-2 shrink-0 ${
                  selected ? "border-fuchsia-500 bg-fuchsia-500" : "border-slate-300"
                }`}>
                  {selected && <span className="block w-full h-full rounded-full ring-2 ring-white" />}
                </span>
                <div className="flex-1 min-w-0">
                  <p className={`text-sm font-medium ${selected ? "text-fuchsia-900" : "text-slate-900"}`}>{o.label}</p>
                  <p className="text-xs text-slate-500 mt-0.5">{o.desc}</p>
                </div>
              </button>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
